import { render } from "./BooksView.vue?vue&type=template&id=2129922e&scoped=true"
import script from "./BooksView.vue?vue&type=script&lang=js"
export * from "./BooksView.vue?vue&type=script&lang=js"

import "./BooksView.vue?vue&type=style&index=0&id=2129922e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2129922e"]])

export default __exports__